import React from 'react';
import './BookingPage.css';

import { BookingForm, PageTitle } from '../../../components';


const BookingPage = () => (

  <div className='booking-page'>

    {/* Page Title */}
    <PageTitle title={'Car Booking'} page={'Car Booking'} />

    <section className="booking-form">
      <div className="box-container">
        <div className="content">
          <BookingForm formType="booking-page" />
        </div>
      </div>
    </section>

  </div>

);

export default BookingPage;